import type { RhinoImage, RhinoImageRatio } from '../../data';
import type { VodAssetMetas } from '../../data/asset';
import { tvpil } from '../../data/compat/tvpil';
import { RhinoRating } from '../../data/type';
import type { ICatalogItem, MediaImage } from '../objects';

export function processMediaImages(images: MediaImage[]): RhinoImage[] {
  return images.map((image: MediaImage) => {
    return {
      ratio: image.imageType.ratio.name as RhinoImageRatio,
      type: image.imageType.id,
      url: image.url,
    };
  });
}

export function processVodAssetMetas(metas: ICatalogItem['metadata']): VodAssetMetas {
  return {
    ...(metas?.['MarkerBackgroundColor'] && {
      contentMarkerBackgroundColor: String(metas['MarkerBackgroundColor']),
    }),
    ...(metas?.['ContentMarkerText'] && {
      contentMarkerText: String(metas['ContentMarkerText']),
    }),
    ...(metas?.['MarkerTextColor'] && {
      contentMarkerTextColor: String(metas['MarkerTextColor']),
    }),
  };
}

export function processEpisodeMetas(metadata: ICatalogItem['metadata']) {
  return {
    ...(metadata?.['EpisodeName'] && {
      episodeName: String(metadata['EpisodeName']),
    }),
    ...(metadata?.['EpisodeNumber'] && {
      episodeNumber: Number(metadata['EpisodeNumber']),
    }),
    ...(metadata?.['SeasonNumber'] && {
      seasonNumber: Number(metadata['SeasonNumber']),
    }),
    ...(metadata?.['SeriesID'] && {
      seriesId: String(metadata['SeriesID']),
    }),
  };
}

/**
 * @see https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/3613229074/Rating+Spec#TVPIL-Task
 */
export function getRating(metadata: ICatalogItem['metadata']): RhinoRating | undefined {
  const rating = tvpil.availableRatings.find((r) => {
    const metaValue = metadata?.[r.name];

    return metaValue && parseInt(metaValue as string) > -1;
  });

  if (!rating) {
    return undefined;
  }

  return {
    name: rating.name,
    value: metadata?.[rating.name] as string,
  };
}
